import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Filter, Search, ChevronDown, MoreHorizontal, Download, Upload, Plus, X, ChevronUp, ChevronDown as ChevronDownSort, ArrowUpCircle, ArrowDownCircle } from 'lucide-react';
import Dashboard from '../components/Dashboard';
import AddPatientModal from '../components/AddPatientModal';
import './UsersList.css';
import { handleAvatarError } from '../constants/avatars';

const UsersList = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All selected (7)');
  const [segmentFilter, setSegmentFilter] = useState('Any segment');
  const [timeFilter, setTimeFilter] = useState('Last 7 days');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [addPatientModalOpen, setAddPatientModalOpen] = useState(false);
  const [editingPatient, setEditingPatient] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  // Mock user data based on the image - moved to state to allow adding new patients
  const [users, setUsers] = useState([
    {
      id: 42,
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+10.3%',
      scheduleAdherence: '15.9%',
      overallAdherence: '15.9%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 43,
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+10.3%',
      scheduleAdherence: '20.7%',
      overallAdherence: '20.7%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 44,
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+10.3%',
      scheduleAdherence: '10.3%',
      overallAdherence: '10.3%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 45,
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+10.3%',
      scheduleAdherence: '100%',
      overallAdherence: '100%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 46,
      avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM5Q0EzQUYiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI0Y5RkFGQiIvPgo8cGF0aCBkPSJNMzIgMzJDMzIgMjYuNDc3MiAyNy41MjI4IDIyIDIyIDIySDEyQzYuNDc3MTUgMjIgMiAyNi40NzcyIDIgMzJWNDBIMzJWMzJaIiBmaWxsPSIjRjlGQUZCIi8+Cjwvc3ZnPgo=',
      weekTrend: '+10.3%',
      scheduleAdherence: '15.3%',
      overallAdherence: '15.3%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Not Assigned',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 47,
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+10.3%',
      scheduleAdherence: '35.8%',
      overallAdherence: '35.8%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 48,
      avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM5Q0EzQUYiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI0Y5RkFGQiIvPgo8cGF0aCBkPSJNMzIgMzJDMzIgMjYuNDc3MiAyNy41MjI4IDIyIDIyIDIySDEyQzYuNDc3MTUgMjIgMiAyNi40NzcyIDIgMzJWNDBIMzJWMzJaIiBmaWxsPSIjRjlGQUZCIi8+Cjwvc3ZnPgo=',
      weekTrend: '+10.3%',
      scheduleAdherence: '1.3%',
      overallAdherence: '1.3%',
      dosingOpportunities: '219 / 1376 (-1157)',
      daysInTreatment: 1023,
      doseAdminTime: -198,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 8, 2025'
    },
    {
      id: 49,
      avatar: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+8.7%',
      scheduleAdherence: '78.2%',
      overallAdherence: '78.2%',
      dosingOpportunities: '312 / 400 (-88)',
      daysInTreatment: 456,
      doseAdminTime: 45,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 15, 2025'
    },
    {
      id: 50,
      avatar: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+15.4%',
      scheduleAdherence: '92.1%',
      overallAdherence: '92.1%',
      dosingOpportunities: '445 / 484 (-39)',
      daysInTreatment: 723,
      doseAdminTime: -12,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 12, 2025'
    },
    {
      id: 51,
      avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '-5.2%',
      scheduleAdherence: '45.8%',
      overallAdherence: '45.8%',
      dosingOpportunities: '178 / 389 (-211)',
      daysInTreatment: 234,
      doseAdminTime: -87,
      away: true,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 20, 2025'
    },
    {
      id: 52,
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+12.8%',
      scheduleAdherence: '67.3%',
      overallAdherence: '67.3%',
      dosingOpportunities: '289 / 429 (-140)',
      daysInTreatment: 612,
      doseAdminTime: 23,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 18, 2025'
    },
    {
      id: 53,
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+22.1%',
      scheduleAdherence: '89.4%',
      overallAdherence: '89.4%',
      dosingOpportunities: '567 / 634 (-67)',
      daysInTreatment: 892,
      doseAdminTime: 8,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 10, 2025'
    },
    {
      id: 54,
      avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM5Q0EzQUYiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI0Y5RkFGQiIvPgo8cGF0aCBkPSJNMzIgMzJDMzIgMjYuNDc3MiAyNy41MjI4IDIyIDIyIDIySDEyQzYuNDc3MTUgMjIgMiAyNi40NzcyIDIgMzJWNDBIMzJWMzJaIiBmaWxsPSIjRjlGQUZCIi8+Cjwvc3ZnPgo=',
      weekTrend: '-3.9%',
      scheduleAdherence: '23.7%',
      overallAdherence: '23.7%',
      dosingOpportunities: '98 / 413 (-315)',
      daysInTreatment: 156,
      doseAdminTime: -145,
      away: true,
      pillboxStatus: 'Not Assigned',
      nextFollowUp: 'Dec 25, 2025'
    },
    {
      id: 55,
      avatar: 'https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+18.6%',
      scheduleAdherence: '76.9%',
      overallAdherence: '76.9%',
      dosingOpportunities: '334 / 434 (-100)',
      daysInTreatment: 678,
      doseAdminTime: 34,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 14, 2025'
    },
    {
      id: 56,
      avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '-7.3%',
      scheduleAdherence: '58.2%',
      overallAdherence: '58.2%',
      dosingOpportunities: '223 / 383 (-160)',
      daysInTreatment: 445,
      doseAdminTime: -56,
      away: false,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 22, 2025'
    },
    {
      id: 57,
      avatar: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+14.2%',
      scheduleAdherence: '84.1%',
      overallAdherence: '84.1%',
      dosingOpportunities: '423 / 503 (-80)',
      daysInTreatment: 751,
      doseAdminTime: 15,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 16, 2025'
    },
    {
      id: 58,
      avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM5Q0EzQUYiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI0Y5RkFGQiIvPgo8cGF0aCBkPSJNMzIgMzJDMzIgMjYuNDc3MiAyNy41MjI4IDIyIDIyIDIySDEyQzYuNDc3MTUgMjIgMiAyNi40NzcyIDIgMzJWNDBIMzJWMzJaIiBmaWxsPSIjRjlGQUZCIi8+Cjwvc3ZnPgo=',
      weekTrend: '-9.8%',
      scheduleAdherence: '41.6%',
      overallAdherence: '41.6%',
      dosingOpportunities: '167 / 401 (-234)',
      daysInTreatment: 289,
      doseAdminTime: -112,
      away: true,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 28, 2025'
    },
    {
      id: 59,
      avatar: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+16.7%',
      scheduleAdherence: '73.5%',
      overallAdherence: '73.5%',
      dosingOpportunities: '356 / 484 (-128)',
      daysInTreatment: 567,
      doseAdminTime: 28,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 13, 2025'
    },
    {
      id: 60,
      avatar: 'https://images.unsplash.com/photo-1504593811423-6dd665756598?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '+11.9%',
      scheduleAdherence: '95.3%',
      overallAdherence: '95.3%',
      dosingOpportunities: '612 / 642 (-30)',
      daysInTreatment: 934,
      doseAdminTime: 5,
      away: false,
      pillboxStatus: 'Online',
      nextFollowUp: 'Dec 9, 2025'
    },
    {
      id: 61,
      avatar: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '-6.4%',
      scheduleAdherence: '52.8%',
      overallAdherence: '52.8%',
      dosingOpportunities: '201 / 381 (-180)',
      daysInTreatment: 378,
      doseAdminTime: -73,
      away: false,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 24, 2025'
    },
    {
      id: 62,
      avatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM5Q0EzQUYiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI0Y5RkFGQiIvPgo8cGF0aCBkPSJNMzIgMzJDMzIgMjYuNDc3MiAyNy41MjI4IDIyIDIyIDIySDEyQzYuNDc3MTUgMjIgMiAyNi40NzcyIDIgMzJWNDBIMzJWMzJaIiBmaWxsPSIjRjlGQUZCIi8+Cjwvc3ZnPgo=',
      weekTrend: '+19.5%',
      scheduleAdherence: '87.2%',
      overallAdherence: '87.2%',
      dosingOpportunities: '489 / 561 (-72)',
      daysInTreatment: 823,
      doseAdminTime: 18,
      away: false,
      pillboxStatus: 'Not Assigned',
      nextFollowUp: 'Dec 11, 2025'
    },
    {
      id: 63,
      avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=40&h=40&fit=crop&crop=face&auto=format',
      weekTrend: '-4.1%',
      scheduleAdherence: '38.9%',
      overallAdherence: '38.9%',
      dosingOpportunities: '145 / 373 (-228)',
      daysInTreatment: 198,
      doseAdminTime: -134,
      away: true,
      pillboxStatus: 'Offline',
      nextFollowUp: 'Dec 26, 2025'
    }
  ]);

  const handleUserClick = (userId) => {
    setSelectedPatientId(userId);
    const patient = users.find(u => u.id === userId);
    if (patient) {
      // Initialize edit form with current patient data
      setEditingPatient({
        id: patient.id,
        emailAddress: `patient${patient.id}@example.com`,
        cellPhone: '(916) 555-1212',
        site: 'Site A - Main Hospital'
      });
    }
    setModalOpen(true);
    setHasUnsavedChanges(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedPatientId(null);
    setEditingPatient(null);
    setHasUnsavedChanges(false);
  };

  const handlePatientChangeInModal = (newPatientId) => {
    setSelectedPatientId(newPatientId);
  };

  const handleAddPatient = () => {
    setAddPatientModalOpen(true);
  };

  const handleCloseAddPatientModal = () => {
    setAddPatientModalOpen(false);
  };

  const handleSubmitNewPatient = (newPatient) => {
    setUsers(prev => [...prev, newPatient]);
    setAddPatientModalOpen(false);
  };

  const handlePatientEditChange = (field, value) => {
    setEditingPatient(prev => ({
      ...prev,
      [field]: value
    }));
    setHasUnsavedChanges(true);
  };

  const formatPhoneNumber = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 6) return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
  };

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    handlePatientEditChange('cellPhone', formatted);
  };

  const handleSavePatientChanges = () => {
    // In a real app, this would save to backend
    console.log('Saving patient changes:', editingPatient);
    
    // Update the patient in the users list
    setUsers(prev => prev.map(user => 
      user.id === editingPatient.id 
        ? { ...user, ...editingPatient }
        : user
    ));
    
    setHasUnsavedChanges(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Online': return '#16a34a';
      case 'Offline': return '#6b7280';
      case 'Not Assigned': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const getStatusTextColor = (status) => {
    return status === 'Not Assigned' ? '#92400e' : 'white';
  };

  // Sorting function
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortValue = (user, key) => {
    switch (key) {
      case 'id':
        return user.id;
      case 'weekTrend':
        return parseFloat(user.weekTrend.replace('%', ''));
      case 'scheduleAdherence':
        return parseFloat(user.scheduleAdherence.replace('%', ''));
      case 'overallAdherence':
        return parseFloat(user.overallAdherence.replace('%', ''));
      case 'dosingOpportunities':
        return parseInt(user.dosingOpportunities.split(' / ')[0]);
      case 'daysInTreatment':
        return user.daysInTreatment;
      case 'doseAdminTime':
        return user.doseAdminTime;
      case 'pillboxStatus':
        return user.pillboxStatus;
      case 'nextFollowUp':
        return new Date(user.nextFollowUp);
      default:
        return user[key];
    }
  };

  const renderSortIcon = (columnKey) => {
    if (sortConfig.key !== columnKey) {
      return (
        <span className="sort-icons">
          <ChevronUp size={12} className="sort-icon inactive" />
          <ChevronDownSort size={12} className="sort-icon inactive" />
        </span>
      );
    }
    
    return (
      <span className="sort-icons">
        <ChevronUp size={12} className={`sort-icon ${sortConfig.direction === 'asc' ? 'active' : 'inactive'}`} />
        <ChevronDownSort size={12} className={`sort-icon ${sortConfig.direction === 'desc' ? 'active' : 'inactive'}`} />
      </span>
    );
  };

  const filteredUsers = users.filter(user => 
    user.id.toString().includes(searchTerm) ||
    user.pillboxStatus.toLowerCase().includes(searchTerm.toLowerCase())
  ).sort((a, b) => {
    if (!sortConfig.key) return 0;
    
    const aValue = getSortValue(a, sortConfig.key);
    const bValue = getSortValue(b, sortConfig.key);
    
    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  return (
    <div className="users-list-page">
      <div className="users-header">
        <h1>Patients Management</h1>
        <div className="users-actions">
          <button className="action-button primary" onClick={handleAddPatient}>
            <Plus size={16} />
            Add Patient
          </button>
          <button className="action-button secondary">
            <Upload size={16} />
            Import
            <ChevronDown size={14} />
          </button>
          <button className="action-button secondary">
            <Download size={16} />
            Export
          </button>
        </div>
      </div>

      <div className="users-filters">
        <div className="search-filter">
          <Search className="search-icon" size={16} />
          <input
            type="text"
            placeholder="Filter by keyword"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="filter-search"
          />
        </div>
        
        <div className="filter-dropdowns">
          <select 
            value={selectedFilter} 
            onChange={(e) => setSelectedFilter(e.target.value)}
            className="filter-dropdown"
          >
            <option>All selected (7)</option>
            <option>Online only</option>
            <option>Offline only</option>
          </select>
          
          <select 
            value={segmentFilter} 
            onChange={(e) => setSegmentFilter(e.target.value)}
            className="filter-dropdown"
          >
            <option>Any segment</option>
            <option>High adherence</option>
            <option>Low adherence</option>
          </select>
          
          <select 
            value={timeFilter} 
            onChange={(e) => setTimeFilter(e.target.value)}
            className="filter-dropdown"
          >
            <option>Last 7 days</option>
            <option>Last 30 days</option>
            <option>Last 90 days</option>
          </select>
          
          <button className="more-filters">
            <Filter size={16} />
            More filters
            <ChevronDown size={14} />
          </button>
        </div>
      </div>

      <div className="users-stats">
        <span>Showing {filteredUsers.length} patients</span>
      </div>

      <div className="users-table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th className="sortable" onClick={() => handleSort('id')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>ID</div>
                  <div>{renderSortIcon('id')}</div>
                </div>
              </th>
              <th className="sortable" onClick={() => handleSort('weekTrend')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>2wk Trend</div>
                  <div>{renderSortIcon('weekTrend')}</div>
                </div>
              </th>
              <th className="sortable" onClick={() => handleSort('scheduleAdherence')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>Schedule Adherence</div>
                  <div>{renderSortIcon('scheduleAdherence')}</div>
                </div>
              </th>
              <th className="sortable" onClick={() => handleSort('overallAdherence')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>Overall Adherence</div>
                  <div>{renderSortIcon('overallAdherence')}</div>
                </div>
              </th>
              <th className="sortable" onClick={() => handleSort('dosingOpportunities')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>Dosing Opportunities</div>
                  <div>{renderSortIcon('dosingOpportunities')}</div>
                </div>
              </th>
              <th className="sortable" onClick={() => handleSort('daysInTreatment')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>Days in Treatment</div>
                  <div>{renderSortIcon('daysInTreatment')}</div>
                </div>
              </th>
              <th className="sortable" onClick={() => handleSort('doseAdminTime')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>Dose Admin. Time</div>
                  <div>{renderSortIcon('doseAdminTime')}</div>
                </div>
              </th>
              <th>Away</th>
              <th className="sortable" onClick={() => handleSort('pillboxStatus')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>Pillbox Status</div>
                  <div>{renderSortIcon('pillboxStatus')}</div>
                </div>
              </th>
              <th className="sortable" onClick={() => handleSort('nextFollowUp')}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div>Next Follow Up</div>
                  <div>{renderSortIcon('nextFollowUp')}</div>
                </div>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr 
                key={user.id} 
                className="user-row"
                onClick={() => handleUserClick(user.id)}
              >
                <td>
                  <div className="user-id-cell">
                    {user.avatar ? (
                      <img
                        src={user.avatar}
                        alt={`User ${user.id}`}
                        className="user-avatar"
                        onError={handleAvatarError}
                      />
                    ) : (
                      <div className="user-avatar-placeholder">
                        <div className="avatar-icon"></div>
                      </div>
                    )}
                    <span className="user-id">{user.id}</span>
                  </div>
                </td>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                    {user.weekTrend.startsWith('+') ? (
                      <ArrowUpCircle size={16} style={{ color: '#16a34a' }} />
                    ) : user.weekTrend.startsWith('-') ? (
                      <ArrowDownCircle size={16} style={{ color: '#dc2626' }} />
                    ) : null}
                    <span>{user.weekTrend}</span>
                  </div>
                </td>
                <td>{user.scheduleAdherence}</td>
                <td>{user.overallAdherence}</td>
                <td>{user.dosingOpportunities}</td>
                <td>{user.daysInTreatment}</td>
                <td>{user.doseAdminTime}</td>
                <td>
                  <span className="away-indicator">×</span>
                </td>
                <td>
                  <span 
                    className="status-badge"
                    style={{ 
                      backgroundColor: getStatusColor(user.pillboxStatus),
                      color: getStatusTextColor(user.pillboxStatus)
                    }}
                  >
                    {user.pillboxStatus}
                  </span>
                </td>
                <td>{user.nextFollowUp}</td>
                <td>
                  <button className="actions-button" onClick={(e) => e.stopPropagation()}>
                    <MoreHorizontal size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Patient Detail Modal */}
      {modalOpen && selectedPatientId && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Patient {selectedPatientId} Details</h2>
              <div className="modal-header-actions">
                {hasUnsavedChanges && (
                  <button className="save-changes-btn" onClick={handleSavePatientChanges}>
                    Save Changes
                  </button>
                )}
                <button className="modal-close" onClick={handleCloseModal}>
                  <X size={24} />
                </button>
              </div>
            </div>
            
            {/* Patient Edit Form */}
            {editingPatient && (
              <div className="patient-edit-header">
                <div className="patient-edit-fields">
                  <div className="edit-field">
                    <label className="edit-field-label">Email Address</label>
                    <input
                      type="email"
                      value={editingPatient.emailAddress}
                      onChange={(e) => handlePatientEditChange('emailAddress', e.target.value)}
                      className="edit-field-input"
                    />
                  </div>
                  <div className="edit-field">
                    <label className="edit-field-label">Cell Phone</label>
                    <input
                      type="tel"
                      value={editingPatient.cellPhone}
                      onChange={handlePhoneChange}
                      className="edit-field-input"
                      maxLength={14}
                    />
                  </div>
                  <div className="edit-field">
                    <label className="edit-field-label">Site</label>
                    <select
                      value={editingPatient.site}
                      onChange={(e) => handlePatientEditChange('site', e.target.value)}
                      className="edit-field-select"
                    >
                      <option value="Site A - Main Hospital">Site A - Main Hospital</option>
                      <option value="Site B - North Clinic">Site B - North Clinic</option>
                      <option value="Site C - South Clinic">Site C - South Clinic</option>
                      <option value="Site D - East Campus">Site D - East Campus</option>
                      <option value="Site E - West Campus">Site E - West Campus</option>
                    </select>
                  </div>
                </div>
              </div>
            )}
            
            <div className="chart-panel">
              <Dashboard 
                patientId={selectedPatientId} 
                onPatientChange={handlePatientChangeInModal}
              />
            </div>
          </div>
        </div>
      )}

      {/* Add Patient Modal */}
      <AddPatientModal
        isOpen={addPatientModalOpen}
        onClose={handleCloseAddPatientModal}
        onSubmit={handleSubmitNewPatient}
      />
    </div>
  );
};

export default UsersList;



